export default "__VITE_ASSET__w3vbNR20__"